import { css } from "@emotion/css";
import { IconButton, Tooltip } from "@octopusdeploy/design-system-components";
import { ArrowExpandIcon, DuplicateIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, borderWidth, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import React, { useRef } from "react";
import type { CodeProps, CodeComponent } from "~/components/Code/Code";
import { Code } from "~/components/Code/Code";
const styles = {
    codeViewerHeader: css({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: space[16],
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        padding: `${space[8]} ${space[12]}`,
        borderTopRightRadius: borderRadius["small"],
        borderTopLeftRadius: borderRadius["small"],
    }),
    codeViewerContainer: css({
        position: "relative",
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        borderTop: 0,
        borderBottomRightRadius: borderRadius["small"],
        borderBottomLeftRadius: borderRadius["small"],
        //this is required for the outer border radius to properly clip content
        overflow: "auto",
    }),
};
type CodeWithChromeProps = CodeProps & {
    canShowFullScreen?: boolean;
    canCopy?: boolean;
};
export const CodeWithChrome = (props: CodeWithChromeProps) => {
    const { canShowFullScreen, canCopy, ...rest } = props;
    const codeRef = useRef<CodeComponent>(null);
    return (<div>
            <div className={styles.codeViewerHeader}>
                {canCopy && (<Tooltip content={"Copy to clipboard"}>
                        <IconButton customIcon={<DuplicateIcon size={20} color={themeTokens.color.icon.primary}/>} onClick={async () => await codeRef.current?.copyToClipboard()}/>
                    </Tooltip>)}
                {canShowFullScreen && (<Tooltip content={"Enter full screen"}>
                        <IconButton customIcon={<ArrowExpandIcon size={20} color={themeTokens.color.icon.primary}/>} onClick={() => codeRef.current?.showInFullScreen()}/>
                    </Tooltip>)}
            </div>
            <div className={styles.codeViewerContainer}>
                <Code ref={codeRef} {...rest}/>
            </div>
        </div>);
};
